var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-button',{staticClass:"w-100",attrs:{"type":"primary","size":"large"},on:{"click":function($event){return _vm.downloadData('sample.json')}}},[_vm._v(" Download data ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }